<template>
  <b-card>
    <b-row>
      <!-- User Info: Left col -->
      <b-col
        cols="21"
        xl="6"
        class="d-flex justify-content-between flex-column"
      >
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex justify-content-start">
          <b-avatar
            :src="userData.avatar"
            :text="avatarText(userData.full_name)"
            size="104px"
            rounded
          />
          <div class="d-flex flex-column justify-content-center ml-1">
            <div class="mb-1">
              <h4 class="mb-0">
                {{ userData.full_name }}
                <small
                  v-if="userData.ministry_user_type"
                  class="alert alert-info px-50"
                  >حساب مركزي</small
                >
              </h4>

              <span class="card-text">{{ userData.email }}</span>
            </div>
            <div class="d-flex flex-wrap">
              <b-button
                @click="$emit('editClicked')"
                variant="primary"
                v-can="{ slug: $route.meta.slug, action: 'U' }"
              >
                تعديل
              </b-button>
              <b-button
                v-if="$route.path.includes('ministry-user')"
                v-can="{ slug: 'ministry_users_passwords', action: 'U' }"
                @click="$emit('changePasswordClicked')"
                variant="info"
                class="ml-1"
              >
                تغيير كلمة السر
              </b-button>
              <b-button
                v-else
                v-can="{ slug: 'ministry_ngo_users_passwords', action: 'U' }"
                @click="$emit('changePasswordClicked')"
                variant="info"
                class="ml-1"
              >
                تغيير كلمة السر
              </b-button>
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                @click="onDeleteClicked(userData.id)"
                variant="outline-danger"
                class="ml-1"
              >
                حذف
              </b-button>
            </div>
          </div>
        </div>
        <div v-if="false">
          <b-badge
            style="vertical-align: center"
            class="px-1 py-50"
            variant="light-danger"
          >
            <feather-icon class="mr-25" icon="SlashIcon" />
            <span> محظور </span>
          </b-badge>
          <b-badge
            style="vertical-align: center"
            class="px-1 mx-1 py-50"
            variant="light-secondary"
          >
            <feather-icon class="mr-25" icon="LockIcon" />
            <span> مقفل </span>
          </b-badge>
          <b-badge
            style="vertical-align: center"
            class="px-1 py-50"
            variant="light-success"
          >
            <feather-icon class="mr-25" icon="CheckCircleIcon" />
            <span> فعال </span>
          </b-badge>
        </div>
        <!-- User Stats -->
      </b-col>

      <!-- Right Col: Table -->
      <b-col cols="12" xl="6">
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th>
              <feather-icon size="18" icon="UserIcon" class="mr-75" />
              <span style="font-size: medium" class="font-weight-bold"
                >اسم المستخدم</span
              >
            </th>
            <td style="font-size: medium" class="pb-1">
              {{ userData.username }}
            </td>
          </tr>

          <tr>
            <th>
              <feather-icon icon="ClockIcon" class="mr-75" />
              <span class="font-weight-bold">تاريخ الميلاد</span>
            </th>
            <td class="text-capitalize">
              {{ userData.dob }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="MapPinIcon" class="mr-75" />
              <span class="font-weight-bold">المحافظة</span>
            </th>
            <td>
              {{ userData.governorate ? userData.governorate.name_ar : "" }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="SmartphoneIcon" class="mr-75" />
              <span class="font-weight-bold">رقم الهاتف الجوال</span>
            </th>
            <td>{{ userData.mobile }}</td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="PhoneIcon" class="mr-75" />
              <span class="font-weight-bold">رقم الهاتف الأرضي</span>
            </th>
            <td>{{ userData.phone }}</td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BBadge, BButton, BAvatar, BRow, BCol } from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BBadge,
    BButton,
    BRow,
    BCol,
    BAvatar,
    ToastificationContent,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      avatarText,
    };
  },
  methods: {
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المستخدم ؟", {
          title: "يرجى تأكيد حذف المستخدم",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.$emit("deleteClicked", id);
          }
        });
    },
  },
};
</script>

<style></style>
